// Tab switching utility function
export const switchTab = (tabName: string, cardId: string) => {
  // Remove active class from all tab buttons
  const tabButtons = document.querySelectorAll(`[data-character-id="${cardId}"] .tab-btn`);
  tabButtons.forEach(btn => btn.classList.remove('active'));

  // Add active class to clicked tab button
  const activeButton = document.querySelector(`[data-character-id="${cardId}"] .tab-btn[data-tab="${tabName}"]`);
  if (activeButton) {
    activeButton.classList.add('active');
  }

  // Hide all tab content
  const tabContents = document.querySelectorAll(`[data-character-id="${cardId}"] .tab-content`);
  tabContents.forEach(content => {
    (content as HTMLElement).style.display = 'none';
    content.classList.add('hidden');
  });

  // Show the selected tab content
  const activeContent = document.querySelector(`[data-character-id="${cardId}"] #tab-${tabName}`);
  if (activeContent) {
    (activeContent as HTMLElement).style.display = 'block';
    activeContent.classList.remove('hidden');
  }
};

// Initialize tab switching for a character card
export const initializeTabSwitching = (cardId: string) => {
  const tabButtons = document.querySelectorAll(`[data-character-id="${cardId}"] .tab-btn`);
  
  tabButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const tabName = (e.target as HTMLElement).getAttribute('data-tab');
      if (tabName) {
        switchTab(tabName, cardId);
      }
    });
  });
}; 